<template>
  <div class="integration-actions ml-1">
    <router-link :to="`/integrations/${integration.id}/feeds/new`">
      <el-button
        class="mr-1"
        type="primary"
        size="small"
        icon="PlusElementIcon"
        round
      >
        Add feed
      </el-button>
    </router-link>
    <el-tooltip class="item" effect="dark" placement="top-start" content="Edit">
      <router-link :to="`/integrations/edit/${integration.id}`" title="Edit">
        <el-button
          type="success"
          plain
          circle
          size="small"
          icon="EditElementIcon"
          class="small-action-btn"
        />
      </router-link>
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      placement="top-start"
      content="History"
    >
      <router-link :to="`/history/FeedFormat/${integration.id}`">
        <el-button
          type="info"
          plain
          circle
          size="small"
          icon="TimerElementIcon"
          class="small-action-btn"
        />
      </router-link>
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      placement="top-start"
      content="Clone integration"
    >
      <router-link :to="`/integrations/clone/${integration.id}`" title="Clone">
        <el-button
          type="primary"
          plain
          circle
          size="small"
          icon="CopyDocumentElementIcon"
          class="small-action-btn"
        />
      </router-link>
    </el-tooltip>
    <el-tooltip
      v-if="showDelete"
      class="item"
      effect="dark"
      placement="top-start"
      content="Delete"
    >
      <el-popconfirm
        confirm-button-text="OK"
        cancel-button-text="No, Thanks"
        confirm-button-type="danger"
        icon="InfoFilledElementIcon"
        icon-color="red"
        :title="`Are you sure to delete '${integration.source}'?`"
        @confirm="onDelete"
      >
        <template #reference>
          <el-button
            type="danger"
            plain
            circle
            size="small"
            icon="DeleteElementIcon"
            class="small-action-btn"
          />
        </template>
      </el-popconfirm>
    </el-tooltip>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useFeedFormatsStore } from '@/apps/traforama/store/feedFormats'
import { ElMessage } from 'element-plus'

export default defineComponent({
  name: 'IntegrationActions',
  props: {
    integration: {
      type: Object,
      required: true
    },
    showDelete: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const feedFormatsStore = useFeedFormatsStore()
    const onDelete = () => {
      const feedFormatId = props.integration.id.toString()
      feedFormatsStore.DestroyItem(feedFormatId).then(() => {
        ElMessage({
          message: 'FeedFormat has been deleted',
          type: 'success'
        })
      })
    }

    return { onDelete }
  }
})
</script>

<style lang="scss" scoped>
.mr-1 {
  margin-right: 1em;
}
.integration-actions {
  min-width: 266px;
}
.mobile .integration-actions {
  display: flex;
  margin-top: 0.5em;
  justify-content: flex-end;
}

.el-dropdown-menu__item a {
  display: inline-block;
  height: 100%;
  width: 100%;
}

.small-action-btn {
  margin-right: 3px;
}
</style>
